export default __webpack_public_path__ + "static/media/logo.03f3b0f4.svg";